
import notify from 'rawr/notify';

const REFRESH_INTERVAL = 12 * 60 * 1000; //12 minutes
const ACCOUNT_URL = `${FYM_ACCOUNTS_URL}/account/api/`;
const REFRESH_URL = `${FYM_ACCOUNTS_URL}/token/refresh/`;
const LOGOUT_URL = `${FYM_ACCOUNTS_URL}/auth/logout/`;
let SSO_LOGIN_URL = `https://account.collegeboard.org/login/login`;
let nextVar = "DURL";
if (DEBUG) {
  SSO_LOGIN_URL = `https://cb.test:8000`;
  nextVar = "next";
}

export { ACCOUNT_URL, REFRESH_URL };

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    const headers = getAuthHeader();
    if (headers.Authorization) {
      fetch(`${FYM_ACCOUNTS_URL}/auth/verify/`, {
        method: 'get',
        headers: headers,
      })
      .then(response => {
        if (response.status === 401 || response.status === 422) {
          forceReauth();
        }
      });
    }
  }
}, false)

export function getPilotLoginUrl() {
  return `${window.current_user.service_base_url}/login`;
}

export function getPilotLogoutUrl() {
  return `${window.current_user.service_base_url}/logout`;
}

export function getAuthHeader() {
  let headers = {};
  const token = window.localStorage.getItem('account_access_token');
  if (token && token !== 'undefined') {
    headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }
  return headers;
}

function urlStartsWith(url) {
  return window.location.pathname.indexOf(url) === 0;
}

export function pathRequiresAuth() {
  return !urlStartsWith('/n/content/pdf');
}

export function forceReauth() {
  window.localStorage.clear();

  if (window.current_user.anonymous && (urlStartsWith("/n/pl") || urlStartsWith("/n/apinsight"))) {
    const nextUrl = encodeURIComponent(window.location.href);
    window.location.href = `${SSO_LOGIN_URL}?${nextVar}=${nextUrl}`;
  }
  else if (window.current_user.pilot === 'current2016' || window.current_user.anonymous) {
    // default redirects users to accounts page
    window.location.href = '/n/account';
  }
  else {
    window.location.href = getPilotLogoutUrl();
  }
}

export function refresh() {
  let token = window.localStorage.getItem('account_refresh_token');
  if(!token || token === 'undefined' || token === 'null') {
    return new Promise((resolve, reject) => {resolve()});
  }
  return fetch(REFRESH_URL, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
  .then(response => response.json())
  .then(json => {
    // set a new access token
    window.localStorage.setItem('account_access_token', json.access_token);
    window.localStorage.setItem('expires', Date.parse(json.expires));
    setTimeout(refresh, REFRESH_INTERVAL);  //refresh every 12 minutes
  })
  .catch(err => {
    console.error(err);
    forceReauth();
  });
}

export function tokenHasExpired() {
  // check that token hasn't expired yet
  const expires = parseInt(window.localStorage.getItem('expires')) || Date.now();
  // auto-refresh happens every 12 mins so ensure token is valid for at least 13 mins
  const timeTillRefresh = Date.now() + (1000 * 60 * 13);
  return expires < timeTillRefresh;
}

export function tokensDontExist() {
  const accessToken = window.localStorage.getItem('account_access_token');
  const refreshToken = window.localStorage.getItem('account_refresh_token');

  return !accessToken || accessToken === 'undefined' || !refreshToken;
}

export function fetchAccount(cb) {
  if (tokensDontExist()) {
    return forceReauth();
  }

  if (tokenHasExpired()) {
    return refresh()
      .then(() => _fetchAccount(cb))
      .catch(err => forceReauth());
  }
  else {
    return _fetchAccount(cb);
  }
}

function _makeRequest(url, options={}) {
    return fetch(url, {
      method: options.method || 'GET',
      headers: getAuthHeader(),
      body: options.data
    })
    .then(response => {
      if (response.status === 401 || response.status === 422) {
        forceReauth();
      }
      return response.json();
    });
}
function _fetchAccount(cb) {
  const adminSubjectsQuery = `adminSubjects{id name subjectProgram}`;
  const teacherSubjectsQuery = `teacherSubjects{id name subjectProgram educationPeriods {id}}`;
  const studentSubjectsQuery = `studentSubjects{id name subjectProgram}`;

  return Promise.all([
    _makeRequest(FYM_INFRA_BACKEND_URL + '/graphql', {method: 'POST',
    data: `{"query": "query getSubjectsAccount{me{programs} ${adminSubjectsQuery} ${teacherSubjectsQuery} ${studentSubjectsQuery}}"}`}),
    _makeRequest(ACCOUNT_URL),
  ])
  .then(([data, user]) => {
    setTimeout(refresh, REFRESH_INTERVAL);  //refresh every 12 minutes
    _.assign(window.current_user, user,
      {
        programs: data.data.me.programs,
        adminSubjects: data.data.adminSubjects,
        teacherSubjects: data.data.teacherSubjects,
        studentSubjects: data.data.studentSubjects
      });
    if (tokensDontExist()) {
      window.localStorage.setItem('account_access_token', user.access_token);
      window.localStorage.setItem('expires', Date.parse(user.expires));
    }
    if (cb) { cb(); }
  })
  .catch(err => {
    console.error(err);
  });
}

export function logout(e) {
  e.preventDefault();

  const old_access_token = window.localStorage.getItem('old_access_token');
  const old_refresh_token = window.localStorage.getItem('old_refresh_token');
  const old_expires = window.localStorage.getItem('old_expires');
  // In case of impersonation, revert back to the impersonater.
  if (old_access_token || old_refresh_token) {

    // Set back to the old tokens
    window.localStorage.setItem('account_access_token', old_access_token);
    window.localStorage.setItem('account_refresh_token', old_refresh_token);
    window.localStorage.setItem('expires', old_expires);

    // Clear the old tokens
    window.localStorage.removeItem('old_access_token');
    window.localStorage.removeItem('old_refresh_token');
    window.localStorage.removeItem('old_expires');

    window.location.href = '/';
  } else {
    // first revoke the token server-side
    fetch(LOGOUT_URL, {
      method: 'POST',
      headers: getAuthHeader(),
    })
    .then(response => response.json())
    .then(json => {
      // if successfully revoked then delete client-side
      window.localStorage.clear();
      if (window.current_user.pilot === 'current2016') {
        window.location.href = json.redirect_url;
      }
      else {
        window.location.href = `${window.current_user.service_base_url}/logout`;
      }
    })
    .catch(err => {
      console.error(err);
    });
  }
}



/** WEBPACK FOOTER **
 ** core/client/rawr/utils/auth.js
 **/